import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TagIcon from '@mui/icons-material/Tag';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { ShortcutHint } from './ShortcutHint';
import * as styles from './SimilarTracksModal.styles';

interface FeedbackReasonDialogProps {
  open: boolean;
  trackTitle: string;
  onClose: () => void;
  onSelectReason: (reason: 'sound' | 'not_sound') => void;
}

export const FeedbackReasonDialog = ({
  open,
  trackTitle,
  onClose,
  onSelectReason,
}: FeedbackReasonDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus
    >
      <DialogTitle>Why is this recommendation not good?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={styles.dialogContentText}>
          Please select the reason why "{trackTitle}" isn't a good match:
        </DialogContentText>
        <Box sx={styles.feedbackButtonsContainer}>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => onSelectReason('sound')}
            startIcon={<GraphicEqIcon />}
            sx={styles.feedbackButton}
          >
            <Box>
              <Typography variant="body1" fontWeight={500}>
                Sound-related
              </Typography>
              <Typography variant="caption" color="text.secondary">
                The track doesn't sound right (tempo, style, mood, etc.)
              </Typography>
              <ShortcutHint label="s" />
            </Box>
          </Button>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => onSelectReason('not_sound')}
            startIcon={<TagIcon />}
            sx={styles.feedbackButton}
          >
            <Box>
              <Typography variant="body1" fontWeight={500}>
                Not sound-related
              </Typography>
              <Typography variant="caption" color="text.secondary">
                The track doesn't fit for other reasons (genre, context,
                preference, etc.)
              </Typography>
              <ShortcutHint label="n" />
            </Box>
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
